import React from 'react'

const LeftArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16" fill="none">
<path d="M0.239325 8.18558L7.97191 0.92653L10.391 3.50581L5.23593 8.344L10.0741 13.499L7.49655 15.9199L0.237558 8.18552L0.239325 8.18558Z" fill="#777777"/>
</svg>
  )
}

export default LeftArrow